<script lang="ts">
    import { inject, type Ref, type InjectionKey } from 'vue'

    type SiteNavType = 'accordion' | 'menu'

    type SiteNavRootContext = {
        type: Ref<SiteNavType>
        active: Ref<string>
    }

    const key = Symbol() as InjectionKey<SiteNavRootContext>
    export const injectSiteNavRootContext = () => inject(key)
</script>
<script setup lang="ts">
    import { provide, toRef, ref } from 'vue'
    import { AccordionRoot, NavigationMenuRoot } from 'radix-vue'

    const props = defineProps<{
        type: SiteNavType
    }>()

    const type = toRef(props, 'type')
    const active = ref<string>()

    provide(key, {
        type,
        active
    })
</script>
<template>
    <AccordionRoot as="nav" v-if="type === 'accordion'" type="single" collapsible>
        <slot />
    </AccordionRoot>
    <NavigationMenuRoot @update:modelValue="active = $event" v-else>
        <slot />
    </NavigationMenuRoot>
</template>